import { Injector } from '@angular/core';
import {
  EIremboFormlyFieldSubTypes,
  TIdType,
} from '@irembo-andela/irembogov3-common';
import { FormlyFieldConfig } from '@ngx-formly/core';
import {
  nidChildNidResponseProps,
  ninIdResponseProps,
} from '../../../../models/custom-id-input-responses.model';
import {
  getDefaultBaseSettingsConfigFormly,
  getUsePrefetchFieldConfig,
  getPopulateRelativeToRootFieldConfig,
  getPopulatesPropsSettingsConfigFormly,
  getFieldLabelSettingsConfigFormly,
  getFieldKeySettingsConfigFormly,
  getMixpanelAnalyticsToggleConfig,
} from '../../form-fields-formly-settings/form-builder-default-settings-configuration-formly-fields.utils';
import {
  nidFieldParseIntoSettingsFormModel,
  nidFieldUpdateFromSettingsFormModel,
} from '../nid-field-type.configuration';
import { defaultSectionConfigFormModel } from '../section-field-type.configuration';
import { fieldsBaseConfigurationFormModel } from '../shared.configuration';
import { BaseFormlyFieldConfiguration } from './base-formly-field-configuration';

export class NIDFormlyFieldConfiguration extends BaseFormlyFieldConfiguration {
  subType!: EIremboFormlyFieldSubTypes;

  constructor(injector: Injector, field: FormlyFieldConfig) {
    super(injector, field);

    const idType: TIdType | undefined = this.field.props?.['idType'];

    switch (idType) {
      case 'NIN':
        this.subType = EIremboFormlyFieldSubTypes.CUSTOM_ID_INPUT_NIN;
        break;
      case 'NID':
        this.subType = EIremboFormlyFieldSubTypes.CUSTOM_ID_INPUT_NID;
        break;
      case 'CHILD_ID':
        this.subType = EIremboFormlyFieldSubTypes.CUSTOM_ID_INPUT_CHILD_ID;
        break;
      default:
        break;
    }

    this.availableValidations.push('idConditions', 'invalidInput', 'invalidId');
    this.setSettings();
  }

  override parseFieldConfigIntoSettingsFormModel() {
    return nidFieldParseIntoSettingsFormModel(this.field);
  }

  override updateFieldConfigFromSettingsFormModel(
    model: any
  ): FormlyFieldConfig {
    return nidFieldUpdateFromSettingsFormModel(model, this.field);
  }

  private setSettings() {
    switch (this.subType) {
      case EIremboFormlyFieldSubTypes.CUSTOM_ID_INPUT_NID:
      case EIremboFormlyFieldSubTypes.CUSTOM_ID_INPUT_CHILD_ID:
        this.settingsFormlyModel = { ...fieldsBaseConfigurationFormModel() };
        this.settingsFormlyForm = [
          ...getDefaultBaseSettingsConfigFormly(this.formBuilderService),
          getUsePrefetchFieldConfig(this.formBuilderService),
          getPopulateRelativeToRootFieldConfig(),
          ...getPopulatesPropsSettingsConfigFormly(this.formBuilderService, [
            ...Array.from(nidChildNidResponseProps),
          ]),
          ...getMixpanelAnalyticsToggleConfig(),
        ];
        break;

      case EIremboFormlyFieldSubTypes.CUSTOM_ID_INPUT_NIN:
        this.settingsFormlyModel = { ...fieldsBaseConfigurationFormModel() };
        this.settingsFormlyForm = [
          ...getDefaultBaseSettingsConfigFormly(this.formBuilderService),
          getUsePrefetchFieldConfig(this.formBuilderService),
          getPopulateRelativeToRootFieldConfig(),
          ...getPopulatesPropsSettingsConfigFormly(this.formBuilderService, [
            ...Array.from(ninIdResponseProps),
          ]),
          ...getMixpanelAnalyticsToggleConfig(),
        ];
        break;

      default:
        this.settingsFormlyModel = defaultSectionConfigFormModel;
        this.settingsFormlyForm = [
          ...getFieldLabelSettingsConfigFormly(this.formBuilderService),
          ...getFieldKeySettingsConfigFormly(this.formBuilderService),
        ];
        break;
    }
  }
}
